import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { FONTS } from '../../../../../constants'

export const FirstRow = React.memo(({ data }) => {
  const { criteria, start_date, end_date } = data

  return (
    <Root>
      <FormWrapper>
        <Label>Criteria</Label>
        <Text>{ criteria || '-' }</Text>
      </FormWrapper>
      <FormWrapper>
        <Label>Start Date - End Date</Label>
        <Text>{ moment(start_date).format('MMM YYYY')} - {moment(end_date).format('MMM YYYY') }</Text>
      </FormWrapper>
      <FormWrapper />
    </Root>
  )
})

const Root = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-top: 12px;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
    padding-right: 6px;
  }

  :nth-last-child(1) {
    padding-left: 6px;
  }
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #808080;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/detail/FirstRow.js